import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Features from './components/Features';
import Footer from './components/Footer';

function App() {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.dir = i18n.dir();
    document.documentElement.lang = i18n.language;
  }, [i18n, i18n.language]);

  return (
    <div className={`min-h-screen bg-slate-50 ${i18n.language === 'ar' ? 'font-arabic' : 'font-sans'}`}>
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Features />
        {/* Call to Action Section */}
        <section className="py-20 bg-marine-600 text-white text-center px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-5xl font-bold mb-6">{t('app.ready_move_cargo')}</h2>
            <p className="text-xl text-marine-100 mb-10">
              {t('app.contact_expert_desc')}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
               <a href="mailto:info@haj-logistics.com" className="px-8 py-4 bg-white text-marine-900 font-bold rounded-lg hover:bg-slate-100 transition-colors shadow-lg">
                 {t('app.email_us')}
               </a>
               <button onClick={() => alert(t('app.alert_call'))} className="px-8 py-4 bg-marine-700 border border-marine-500 text-white font-bold rounded-lg hover:bg-marine-800 transition-colors">
                 {t('app.call_support')}
               </button>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default App;
